/**
 * @fileoverview Back-compat entry for /tuner. The tuner now lives in the
 * segmented Tools screen; this renders it with the tuner tab active.
 */

import ToolsPage from "@/pages/ToolsPage";

const TunerPage = () => <ToolsPage initialTab="tuner" />;

export default TunerPage;
